import { useEffect, useState } from 'react';
import { getPricing } from '../../services/pricing/listPricingService.js';

export const usePricingList = () => {
    const [price, setPrices] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    // feedback
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    // ordenamiento
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    
    useEffect(() => {
        loadPrices();
    }, []);

    const loadPrices = async () => {
        const data = await getPricing();
        data.sort((a, b) => a.name.localeCompare(b.name));
        setPrices(data);
    };

    const handleSort = (field) => {
        const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';

        setSortField(field);
        setSortOrder(order);

        setPrices(prev =>
            [...prev].sort((a, b) => {
                const aValue = field.split('.').reduce((o, i) => o?.[i], a);
                const bValue = field.split('.').reduce((o, i) => o?.[i], b);

                if (aValue < bValue) return order === 'asc' ? -1 : 1;
                if (aValue > bValue) return order === 'asc' ? 1 : -1;
                return 0;
            })
        );
    };

    return {
        price,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        error,
        setError,
        success,
        setSuccess,
        sortField,
        sortOrder,
        setSortField,
        setSortOrder,
        handleSort
    };
}